/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

interface Props {
  color?: string;
}

export const ResetIcon = () => (
  <svg viewBox="0 0 14 14" fill="currentColor" style={{ height: "8px" }}>
    <path d="M8.41,7l5.3-5.29A1,1,0,1,0,12.29.29L7,5.59,1.71.29A1,1,0,0,0,.29,1.71L5.59,7,.29,12.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L7,8.41l5.29,5.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
  </svg>
);

export const PageIcon = ({ color }: Props) => (
  <>
    <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33337 2.70001C3.33337 2.42387 3.55723 2.20001 3.83337 2.20001H10.3525C10.4851 2.20001 10.6123 2.25269 10.706 2.34646L13.5203 5.16067C13.614 5.25444 13.6667 5.38162 13.6667 5.51422V14.3C13.6667 14.5762 13.4428 14.8 13.1667 14.8H3.83337C3.55723 14.8 3.33337 14.5762 3.33337 14.3V2.70001ZM3.83337 1.20001C3.00495 1.20001 2.33337 1.87159 2.33337 2.70001V14.3C2.33337 15.1284 3.00495 15.8 3.83337 15.8H13.1667C13.9951 15.8 14.6667 15.1284 14.6667 14.3V5.51422C14.6667 5.1164 14.5087 4.73487 14.2274 4.45357L11.4132 1.63935C11.1318 1.35805 10.7503 1.20001 10.3525 1.20001H3.83337ZM5.10006 4.60002C4.82392 4.60002 4.60006 4.82388 4.60006 5.10002C4.60006 5.37616 4.82392 5.60002 5.10006 5.60002H8.50006C8.7762 5.60002 9.00006 5.37616 9.00006 5.10002C9.00006 4.82388 8.7762 4.60002 8.50006 4.60002H5.10006ZM5.10006 8.00002C4.82392 8.00002 4.60006 8.22388 4.60006 8.50002C4.60006 8.77616 4.82392 9.00002 5.10006 9.00002H11.9001C12.1762 9.00002 12.4001 8.77616 12.4001 8.50002C12.4001 8.22388 12.1762 8.00002 11.9001 8.00002H5.10006ZM5.10006 11.4C4.82392 11.4 4.60006 11.6239 4.60006 11.9C4.60006 12.1762 4.82392 12.4 5.10006 12.4H11.9001C12.1762 12.4 12.4001 12.1762 12.4001 11.9C12.4001 11.6239 12.1762 11.4 11.9001 11.4H5.10006Z"
        fill={color || "#494949"}
      />
    </svg>
  </>
);

export const UserIcon = () => (
  <>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00008 0.785095C5.11403 0.785095 3.58508 2.31404 3.58508 4.2001C3.58508 5.70657 4.56054 6.98521 5.91428 7.43886C4.85545 7.59083 3.94338 7.98328 3.24816 8.66843C2.32374 9.57947 1.85828 10.9334 1.85828 12.6934C1.85828 12.9557 2.07094 13.1684 2.33328 13.1684C2.59561 13.1684 2.80828 12.9557 2.80828 12.6934C2.80828 11.0934 3.22944 10.0207 3.91499 9.34507C4.60194 8.66806 5.62999 8.31509 6.99988 8.31509C8.36976 8.31509 9.39785 8.66806 10.0848 9.34507C10.7704 10.0207 11.1916 11.0934 11.1916 12.6934C11.1915 12.9557 11.4042 13.1684 11.6665 13.1684C11.9289 13.1684 12.1415 12.9557 12.1416 12.6934C12.1416 10.9334 11.6761 9.57946 10.7516 8.66843C10.0565 7.98334 9.14448 7.5909 8.08576 7.4389C9.43957 6.98528 10.4151 5.70661 10.4151 4.2001C10.4151 2.31404 8.88613 0.785095 7.00008 0.785095ZM4.53508 4.2001C4.53508 2.83871 5.6387 1.7351 7.00008 1.7351C8.36146 1.7351 9.46508 2.83871 9.46508 4.2001C9.46508 5.56148 8.36146 6.6651 7.00008 6.6651C5.6387 6.6651 4.53508 5.56148 4.53508 4.2001Z"
        fill="#494949"
      />
    </svg>
  </>
);

export const ReturnIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 10 4 15 9 20" />
    <path d="M20 4v7a4 4 0 0 1-4 4H4" />
  </svg>
);
